import React, { useState } from 'react';
import * as Icon from 'react-feather';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem }  from 'reactstrap';
import { ConfirmDeleteReportModal } from '.';
import { Can } from '../RBAC/Can';

export const AuditReportsListActions = props => {
    const [state, setState] = useState({
        dropdownOpen: false,
        isConfirmDeleteModalOpen: false
    });

    const toggle = () => {
        setState((prevState) => ({
            ...prevState,
            dropdownOpen: !prevState.dropdownOpen
        }));
    };

    const toggleConfirmDeleteModal = () => {
        setState((prevState) => ({
            ...prevState,
            isConfirmDeleteModalOpen: !prevState.isConfirmDeleteModalOpen
        }));
    };

    const handleDeleteConfirmed = (entity, e) => {
        props.handleDelete(entity, e);
    };

    return (
        <>
            <Can
                perform="reports:edit"
                yes={() => (
                    <>
                        <div className="float-right">
                            <ButtonDropdown direction="left" isOpen={state.dropdownOpen} toggle={toggle} size="sm">
                                <DropdownToggle caret color="primary" size="sm">Actions</DropdownToggle>
                                <DropdownMenu>
                                    <Can
                                        perform="reports:delete"
                                        yes={() => (
                                            <>
                                                <DropdownItem onClick={() => toggleConfirmDeleteModal()}><Icon.Trash2 className="feather" />&nbsp; Delete</DropdownItem>
                                            </>
                                        )}
                                    />
                                </DropdownMenu>
                            </ButtonDropdown>
                        </div>

                        <ConfirmDeleteReportModal
                            isOpen={state.isConfirmDeleteModalOpen}
                            toggle={toggleConfirmDeleteModal}
                            handleConfirm={handleDeleteConfirmed}
                            report={props.report}
                        />
                    </>
                )}
            />
        </>
    );
}